import {EventEmitter, Injectable, Type} from '@angular/core';
import {SbModalState} from './modal-state.service';
import {NavigationStackEntry} from './modal.model';

@Injectable({
  providedIn: 'root'
})
export class ModalNavigationService {

  public onNavigation: EventEmitter<NavigationStackEntry> = new EventEmitter<NavigationStackEntry>();

  constructor(private modalState: SbModalState) {

  }

  getSharedData() {
    return this.modalState.navigationSharedData;
  }

  getCurrentNavigation(): NavigationStackEntry {
    return this.modalState.navigationStack.peek();
  }

  canGoBack(): boolean {
    return this.modalState.navigationStack.size() > 1;
  }

  goBack() {
    this.modalState.navigationStack.pop();
    this.onNavigation.emit();
  }

  clearAndNavigate(component: Type<any>, data: any) {
    this.modalState.navigationStack.clear();
    this.navigate(component, data);
  }

  popAndNavigate(component: Type<any>, data: any) {
    this.modalState.navigationStack.pop();
    this.navigate(component, data);
  }

  navigate(component: Type<any>, pData: any) {
    this.modalState.navigationStack.push({value: component, data: pData});
    this.onNavigation.emit();
  }

  clear() {
    this.modalState.navigationStack.clear();
  }

  result(e: any) {
    this.modalState.modals.get('sbNavigationModal').close(e);
  }
}
